import { ProductV2 } from '@common'

import Grid from '../../components/Grid'
import { useGames } from '../common/useGames'
import ProductCard from '../products/ProductCard'

import styles from './EventOffers.module.scss'

export default function EventOffers(props: { eventBundles: ProductV2[] }) {
  const games = useGames()
  return (
    <section className={styles.Section}>
      <div className={styles.Module}>
        <div className={styles.Container}>
          <div className={styles.Header}>
            <p>Offers</p>
          </div>
          <Grid singleRow additionalClasses={styles.Grid}>
            {props.eventBundles.map((eventBundle) => {
              const game = games.find((g) => g.slug === eventBundle.game)

              if (!game) {
                return null
              }

              return <ProductCard key={eventBundle.id} product={eventBundle} type="Normal" game={game} />
            })}
          </Grid>
        </div>
      </div>
    </section>
  )
}
